/*
 * This source is generated by bin/gen/licon.py. Run licon.py after changing public/font/lichess.sfd
 *
 * Constant names and values are pulled from private use characters defined in the sfd file.
 *
 * Character names can be edited in fontforge's "glyph info" dialog, or by editing the StartChar: line that
 * begins each character chunk in lichess.sfd
 *
 * To make these characters visible in your editor, install the lichess.ttf font (which is also generated by
 * licon.py) and then add it to your editor's font list.
 */

export const licon = {
  CautionTriangle: '' as const, // e000
  Link: '' as const, // e001
  Rabbit: '' as const, // e002
  ShareIos: '' as const, // e003
  ShareAndroid: '' as const, // e004
  Gear: '' as const, // e005
  DieSix: '' as const, // e006
  FlagKingHill: '' as const, // e007
  FlameBlitz: '' as const, // e008
  Feather: '' as const, // e009
  Turtle: '' as const, // e00a
  FlagChessboard: '' as const, // e00b
  ArcheryTarget: '' as const, // e00c
  ThreeCheckStack: '' as const, // e00d
  UploadCloud: '' as const, // e00e
  ExternalArrow: '' as const, // e00f
  AnalogTv: '' as const, // e010
  RssFeed: '' as const, // e011
  StudyBoard: '' as const, // e012
  Shield: '' as const, // e013
  InkQuill: '' as const, // e014
  Target: '' as const, // e015
  Crown: '' as const, // e016
  LineGraph: '' as const, // e017
  GraduateCap: '' as const, // e018
  PaperAirplane: '' as const, // e019
  ZoomIn: '' as const, // e01a
  Expand: '' as const, // e01b
  Atom: '' as const, // e01c
  List: '' as const, // e01d
  Antichess: '' as const, // e01e
  Microscope: '' as const, // e01f
  ChasingArrows: '' as const, // e020
  CrownElite: '' as const, // e021
  Funnel: '' as const, // e022
  Checkmark: '' as const, // e023
  InternalArrow: '' as const, // e024
  PlayTriangle: '' as const, // e025
  GreaterThan: '' as const, // e026
  LessThan: '' as const, // e027
  DiscBig: '' as const, // e028
  DiscBigOutline: '' as const, // e029
  X: '' as const, // e02a
  ArrowDownRight: '' as const, // e02b
  ArrowUpRight: '' as const, // e02c
  PlusButton: '' as const, // e02d
  MinusButton: '' as const, // e02e
  Fire: '' as const, // e02f
  DownTriangle: '' as const, // e030
  UpTriangle: '' as const, // e031
  Bullet: '' as const, // e032
  Swords: '' as const, // e033
  JumpLast: '' as const, // e034
  JumpFirst: '' as const, // e035
  JumpNext: '' as const, // e036
  JumpPrev: '' as const, // e037
  Pause: '' as const, // e038
  Hamburger: '' as const, // e039
  Globe: '' as const, // e03a
  Book: '' as const, // e03b
  BarGraph: '' as const, // e03c
  Keypad: '' as const, // e03d
  Berserk: '' as const, // e03e
  Padlock: '' as const, // e03f
  FlagOutline: '' as const, // e040
  BubbleSpeech: '' as const, // e041
  BubbleConvo: '' as const, // e042
  Envelope: '' as const, // e043
  Group: '' as const, // e044
  Trophy: '' as const, // e045
  ThumbsUp: '' as const, // e046
  Back: '' as const, // e047
  CautionCircle: '' as const, // e048
  NotAllowed: '' as const, // e049
  RandomColor: '' as const, // e04a
  Pencil: '' as const, // e04b
  Cogs: '' as const, // e04c
  Tag: '' as const, // e04d
  Clock: '' as const, // e04e
  Trash: '' as const, // e04f
  User: '' as const, // e050
  StarOutline: '' as const, // e051
  Star: '' as const, // e052
  MoreTriangle: '' as const, // e053
  Eye: '' as const, // e054
  Power: '' as const, // e055
  Download: '' as const, // e056
  Search: '' as const, // e057
  Forward: '' as const, // e058
  UltraBullet: '' as const, // e059
  Storm: '' as const, // e05a
  Tools: '' as const, // e05b
  Bullseye: '' as const, // e05c
  Agent: '' as const, // e05d
  Mic: '' as const, // e05e
  BarChart: '' as const, // e05f
  InfoCircle: '' as const, // e060
  ScreenDesktop: '' as const, // e061
  PhoneMobile: '' as const, // e062
  Multiboard: '' as const, // e063
  HeartOutline: '' as const, // e064
  FlagRacingKings: '' as const, // e065
  Crazyhouse: '' as const, // e066
  Tshirt: '' as const, // e067
  Heart: '' as const, // e068
  RadioTower: '' as const, // e069
  BellOutline: '' as const, // e06a
  Disc: '' as const, // e06b
  Wings: '' as const, // e06c
  DiscOutline: '' as const, // e06d
  Language: '' as const, // e06e
  ArrowThruApple: '' as const, // e06f
  Clipboard: '' as const, // e070
  Move: '' as const, // e071
  Ibeam: '' as const, // e072
  Cancel: '' as const, // e073
  Voice: '' as const, // e074
  OneHalf: '' as const, // e076
  Mute: '' as const, // e077
  Reload: '' as const, // e078
  AccountCircle: '' as const, // e079
  Logo: '' as const, // e07a
  Switch: '' as const, // e07b
  Cpu: '' as const, // e07e
  Prune: '' as const, // e07f
  Friends: '' as const, // e080
};

export type Licon = typeof licon;
export type LiconKey = keyof Licon;
export type LiconValue = Licon[LiconKey];
